import React, { useState, useEffect } from 'react';
import './ProtectedPage.css';
import { getPasscodes } from '../services/passcodeService';

const ProtectedPage = () => {
  const [showPopup, setShowPopup] = useState(true);
  const [passcodes, setPasscodes] = useState([]);
  const [enteredCode, setEnteredCode] = useState('');
  const [unlocked, setUnlocked] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    getPasscodes().then(setPasscodes);
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (passcodes.includes(enteredCode.trim())) {
      setUnlocked(true);
      setShowPopup(false);
    } else {
      setError('Incorrect passcode. Please try again.');
    }
  };

  return (
    <div className="protected-page-wrapper">
      {showPopup && (
        <div className="popup-overlay">
          <div className="popup-content">
            <form className="popup-form" onSubmit={handleSubmit}>
              <h2>🔐 Enter Passcode</h2>
              <input
                type="password"
                value={enteredCode}
                onChange={(e) => setEnteredCode(e.target.value)}
                placeholder="Enter your passcode"
                required
              />
              <button type="submit">Unlock</button>
              {error && <p className="error-msg">{error}</p>}
              <hr/>
              <a
                href="https://wa.me/919310771976?text=Hi%20I%20need%20a%20passcode%20for%20the%20bride's%20note%20page"
                target="_blank"
                rel="noopener noreferrer"
                className="whatsapp-link"
              >
                📲 Get Your Passcode
              </a>
            </form>
          </div>
        </div>
      )}

      {unlocked && (
        <div className="protected-content">
          <div className="top-heading-section">
            <h1>A Sweet Little Note to My Beautiful Bride</h1>
          </div>
          <div className="note-content">
        <p>Hey lovely,<br />
          First of all — a big, sparkly congratulations! ✨ You’re about to begin one of the most magical chapters of your life, and I couldn’t be happier to be a small part of your big day &lt;3...</p>
        <h3>💧 Skin, the Glow Getter</h3>
        <ul>
          <li>Water is your secret weapon – Sip throughout the day.</li>
          <li>Less is more – No harsh treatments or new experiments.</li>
          <li>Consistency is queen – Cleanser, moisturizer, SPF.</li>
        </ul>
        <h3>💆‍♀️ Hair, Your Crown</h3>
        <ul>
          <li>Deep condition weekly.</li>
          <li>Avoid drastic cuts/colors close to the wedding.</li>
          <li>Oil massage = bonus glow + calm mind.</li>
        </ul>
        <h3>🧘‍♀️ Health, the Real Foundation</h3>
        <ul>
          <li>Sleep well — your skin knows when you don’t.</li>
          <li>Move joyfully — twirl, dance, yoga.</li>
          <li>Breathe — take mindful breaks.</li>
        </ul>
        <p>Makeup is the final touch. The real glow is from within.</p>

        <h2>💌 Important Reminders Before Your Makeup & Hair Session</h2>
        <ul>
          <li>❌ Avoid actives (Vit C, AHA, BHA, etc.) for 7 days before.</li>
          <li>🙅‍♀️ Skip facial waxing/bleaching — prefer face shaving.</li>
          <li>👁️ No lash extensions or semi-permanent hair.</li>
          <li>💨 Don’t condition or serum your hair before styling.</li>
          <li>🚿 Avoid salon washes — shampoo at home instead.</li>
          <li>🌿 <strong>A Little Tip:</strong> If possible, avoid applying haldi directly to your face during your Haldi ceremony. It can leave stains or cause skin irritation, which may affect your makeup on the following events.</li>
        </ul>

        <h2>💄 Just a Few Things to Make Your Makeover Smooth & Magical:</h2>
        <ul>
          <li>✨ 3 comfy chairs</li>
          <li>✨ 2 side tables</li>
          <li>✨ Natural light + peaceful room setup</li>
        </ul>

        <h2>Shriji’s Curated Skincare Picks</h2>
        <ul>
          <li><a href="https://www.wishlink.com/share/fjjjb" target="_blank">Moisturiser (simple)</a></li>
          <li><a href="https://www.wishlink.com/share/t7qub" target="_blank">Sunscreen</a></li>
          <li><a href="https://www.wishlink.com/share/uakcu" target="_blank">Sheet mask (TFS)</a></li>
          <li><a href="https://www.wishlink.com/share/stztj" target="_blank">Toner</a></li>
          <li><a href="https://www.wishlink.com/share/nm9a57" target="_blank">Face wash</a></li>
          <li><a href="https://www.wishlink.com/share/zmqzg" target="_blank">Sheet mask</a></li>
          <li><a href="https://www.wishlink.com/share/848ag" target="_blank">Pimple patches</a></li>
          <li><a href="https://www.wishlink.com/share/nptw8" target="_blank">Makeup remover balm</a></li>
          <li><a href="https://www.wishlink.com/share/r9p24" target="_blank">Moisturiser</a></li>
          <li><a href="https://www.wishlink.com/share/r7b5m" target="_blank">Makeup remover</a></li>
          <li><a href="https://www.wishlink.com/share/eywa8 " target="_blank">Serum </a></li>
          <li><a href="https://www.wishlink.com/share/dsxrn " target="_blank">Moisturiser for extremely dry skin </a></li>
          <li><a href="https://www.wishlink.com/share/nj5udf " target="_blank">Hair growth serum </a></li>
          <li><a href="https://www.wishlink.com/share/faegr " target="_blank">Face scrub </a></li>
        </ul>
      </div>
        </div>
      )}
    </div>
  );
};

export default ProtectedPage;
